/** Lets side panels (assistant, sources) read the selection of, or insert into, an open editor. */
export interface EditorBridge {
  insert(markdown: string): void;
  selection(): { text: string; from: number; to: number };
  text(): string;
}

const bridges = new Map<string, EditorBridge>();

export function setEditorBridge(noteId: string, bridge: EditorBridge | null) {
  if (bridge) bridges.set(noteId, bridge);
  else bridges.delete(noteId);
}

export function getEditorBridge(noteId: string) {
  return bridges.get(noteId) ?? null;
}
